import API from "../API";
import utils from "../utils"

export default {
    namespaced: true,

    state: {
        users: [],

        currentUserId: null,
        createdTrims: [],
    },

    getters: {
        getUserById: (state) => (id) => {
            return state.users.find(user => +user.id === +id);
        },

        getUserIndexById: (state) => (id) => {
            return state.users.findIndex(user => +user.id === +id);
        },

        currentUser(state, getters) {
            let userId = state.currentUserId;

            return userId && getters.getUserById(userId);
        },

        userPageUrl: () => (name, id) => {
            let nameAsUrl = utils.textToUrl(name);

            return `/users/${id}-${nameAsUrl}/trims` // profile/trims/statistic
        },

    },

    mutations: {
        setUsers(state, users) {
            state.users = users;
        },

        replaceUser(state, { index, user }) {
            state.users.splice(index, 1, user);
        },

        removeUser(state, index) {
            state.users.splice(index, 1);
        },

        setCurrentUserId(state, id) {
            state.currentUserId = id;
        },

        setCreatedTrims(state, trims) {
            state.createdTrims = trims;
        },

    },

    actions: {
        getUsers({commit}) {
            return new Promise((resolve, reject) => {
                API.users.getUsers().then(
                    (users) => {
                        commit('setUsers', users);

                        resolve(users);
                    },
                    (error) => {
                        reject(error);
                    });
            });
        },

        getUser({state, getters, commit}, userId) {
            return new Promise((resolve, reject) => {
                API.users.getUser(userId).then(
                    (res) => {
                        const user = res.data;

                        if (!user) {
                            resolve();
                            return;
                        }

                        let isUserInList = getters.getUserById(userId);

                        // when site loading first time on the user page we don't have a list of users
                        if (!isUserInList) {
                            let index = state.users.length;

                            commit('replaceUser', { index, user });
                        }

                        resolve(user);
                    },
                    (error) => {
                        reject(error);
                    });
            });
        },

        editUser({state, getters, commit}, {id, userName, email, password, role, active}) {
            return new Promise((resolve, reject) => {
                API.users.edit({id, userName, email, password, role, active}).then(
                    (userData) => {
                        let index = getters.getUserIndexById(userData.id);

                        // old data
                        let { date_created } = state.users[index];

                        // new data
                        let {id, userName, email, role, active} = userData;

                        // data to update in the users list
                        let user = { id, userName, email, role, active, date_created };

                        commit('replaceUser', { index, user });

                        resolve();
                    },
                    (error) => {
                        reject(error);
                    });
            });
        },

        deleteUser({ getters, commit }, userId) {
            return new Promise((resolve, reject) => {
                API.users.delete(userId).then(
                    (data) => {
                        // clear the current/selected user extra data
                        commit('setCurrentUserId', null);
                        commit('setCreatedTrims', []);

                        let { id } = data;
                        let index = getters.getUserIndexById(id);

                        commit('removeUser', index);

                        resolve(id);
                    },
                    (error) => {
                        reject(error);
                    });
            });
        },

        getCreatedTrims({commit}, userId) {
            return new Promise((resolve, reject) => {
                API.users.getCreatedTrims(userId).then(
                    (res) => {
                        let trims = res.data;

                        commit('setCreatedTrims', trims);

                        resolve(trims);
                    },
                    (error) => {
                        reject(error);
                    });
            });
        },

    },

}